import type { MouseEvent } from "react";
import { useMutation } from "react-query";
import { t } from "@/i18n-js/instance";
import { eventApi } from "@circle-react/api";
import type { Event } from "@circle-react/types/Event";
import { useToast } from "@circle-react-uikit/ToastV2";

interface UseDownloadCSVProps {
  event: Event;
}

export const useDownloadCSV = ({ event }: UseDownloadCSVProps) => {
  const { success, error } = useToast();
  const { mutate } = useMutation(() => eventApi.downloadCSV({ event }), {
    onSuccess: data => success(data?.message),
    onError: () => error(t("something_went_wrong")),
  });

  return (e: MouseEvent<HTMLButtonElement>) => {
    e.preventDefault();
    mutate();
  };
};
